import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../axiosInterceptor';

export type UpdateCoachProfilePayload = {
  name?: string;
  first_name?: string;
  last_name?: string;
  bio?: string;
  location?: string;
  timezone?: string;
  avatar?: string;
  phone?: string;
  gender?: string;
  area_of_expertise?: string;
  experience_level?: string;
  linkedin_url?: string;
  instagram_url?: string;
  facebook_url?: string;
  youtube_url?: string;
  twitter_url?: string;
  tiktok_url?: string;
};

type UpdateCoachProfileState = {
  loading: boolean;
  error: boolean;
  errorMessage: string;
  data: unknown | null;
};

const initialState: UpdateCoachProfileState = {
  loading: false,
  error: false,
  errorMessage: '',
  data: null,
};

export const updateCoachProfile = createAsyncThunk<
  unknown,
  UpdateCoachProfilePayload
>('updateCoachProfile', async (payload) => {
  const { data } = await api.put('/api/coaches/me/profile', payload);
  return data;
});

const updateCoachProfileSlice = createSlice({
  name: 'updateCoachProfile',
  initialState,
  reducers: {
    resetUpdateCoachProfile: (state) => {
      state.loading = false;
      state.error = false;
      state.errorMessage = '';
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateCoachProfile.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.errorMessage = '';
    });
    builder.addCase(updateCoachProfile.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(updateCoachProfile.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMessage =
        action.error.message ?? 'Failed to update coach profile.';
    });
  },
});

export const { resetUpdateCoachProfile } = updateCoachProfileSlice.actions;
export default updateCoachProfileSlice.reducer;
